module.exports = __webpack_public_path__ + "img/logo.96429570.png";